import { AnyAction } from "redux";
import { FolderProps } from "../../components/Files/documents/types";
import { Citation } from "../actions/ChatAction";
import { DropdownOption } from "../../components/shared/TailwindComponents/Dropdown";

export interface FolderOption {
  id: string;
  label: string;
}

export interface ImportSummary {
  added: { name: string; email: string }[];
  updated: { name: string; email: string }[];
  errors: { client: string; error: string }[];
  total_added: number;
  total_updated: number;
  total_errors: number;
}

export interface ModalState {
  showModal: boolean;
  type: 'confirmation' | 'feedback' | 'custom' | 'success' | 'error' | 'warning' | 'share' | 'sign' | 'create' | 'create_folder' | 'addFile' | 'forgotPassword' | 'password' | 'payment-options' | "tips" | 'info' | 'receiver-options' | "addSignature" | 'promptfeedback' | "2fa-qrcode" | 'alert' | 'otp-verification' | 'addTask' | 'confirm-upload' | 'subscription-modal' | 'timeStop' | 'redirect' | 'anonymize' | 'translate' | 'license-request' | 'resetPassword' | 'citations' | 'citation' | 'vaultFilePicker' | "suggestedTasks" | 'sign_doc' | 'attachExistingCaseToClient' | 'ai-settings' | 'settings' | 'addTaskComment' | 'workflows' | 'importClients' | 'onboarding-email' | 'addSource' | 'uploadAttachment' | 'imageViewer' | 'fileReader' | 'fileReaderTst' | 'attachmentViewer' | 'editCaseData' | 'addCollaborator' | 'importSummary' | 'declineEngagement' | 'signEngagement' | 'signFinalEngagement' | 'addTextContent' | 'editDraftInstruction' | 'editDescription' | 'editTone' | 'editWritingStyle' | 'giveAccess' | 'fileUploader' | 'confirmInvitation' | 'addMember' | 'linkCase' | 'editMatterData' | 'createClient' | 'editDepartment' | 'editTeam' | 'connectMatter' | 'uploadClientDocument' | 'addClientToMatter' | 'adminCreateRole' | 'adminEditRole' | 'adminAssignRole' | 'adminEditUser' | 'adminInviteUser' | 'versionHistory' | 'manageAccess' | 'templateCollaborators' | 'templatePreview' | 'uploadTableDocuments' | 'addTableColumn' | 'editTableColumn' | 'startReview' | 'reviewDocumentViewer' | 'reviewHelp' | 'playbookHelp' | 'replacePlaybookDocument' | 'tagPicker' | 'auditLogDetail';
  message: string;
  onConfirm?: (data: any, completeTask?: boolean) => void;
  onSave?: (data: any) => void;
  onCancel?: () => void;
  onRefresh?: () => void | Promise<void>;
  duration?: number;
  summaryData?: ImportSummary;
  folderOptions?: FolderProps[];
  selectedModel?: any;
  inputData?: string;
  info?: string;
  title?: string;
  date?: string;
  taskId?: any[];
  fileID?: string;
  width?: string;
  preSelectedFolderId?: string;
  subMsg?: string;
  gap?: number;
  content?: React.ReactNode;
  component?: React.ReactNode;
  citations?: Citation[];
  citation?: Citation;
  tasks?: any[];
  clientId?: string;
  caseId?: string;
  allClients?: any[];
  selectedClients?: string[];
  sourceType?: string;
  files?: File[];
  setFiles?: (files: File[]) => void;
  imageUrl?: string;
  filename?: string;
  fileUrl?: string;
  fileType?: string;
  item?: any;
  category?: string;
  onFilesChange?: (files: File[]) => void;
  rows?: number;
  placeholder?: string;
  employees?: any;
  initialShared?: any;
  icon?: any;
  isDest?: boolean;
  existingMembers?: any[];
  teamId?: string;
  action?: 'AddMember' | 'LinkCase';
  selectedValue?: string | string[];
  matterId?: string;
  matterUuid?: string;
  taskUuid?: string;
  dataSourceUuid?: string;
  chatUuid?: string;
  roles?: DropdownOption[];
  department?: any;
  team?: any;
  onAfterSave?: () => void | Promise<void>;
  clientName?: string;
  clientUuid?: string;
  matters?: any[];
  onMatterConnected?: () => void;
  onDocumentUploadComplete?: () => void;
  totalMatterPages?: number;
  fetchMatters?: (query: string, page: number) => Promise<any[]>;
  role?: any;
  roleId?: string | number;
  user?: any;
  onRoleCreated?: () => void;
  onRoleUpdated?: () => void;
  onUserUpdated?: () => void;
  onInviteSent?: () => void;
  permissions?: any[];
  modules?: any[];
  clientRoleOptions?: DropdownOption[];
  fileId?: string;
  folderId?: string;
  fileName?: string;
  onVersionRestore?: () => void;
  orgType?: string;
  itemId?: string;
  itemType?: 'file' | 'folder';
  itemName?: string;
  itemCollaborators?: any[];
  creatorId?: string;
  collaborators?: any[];
  currentUserUuid?: string;
  onCollaboratorsChange?: (collaborators: any[]) => void;
  templateBranding?: any;
  tableUuid?: string;
  columnToEdit?: any;
  reviewUuid?: string;
  sessionUuid?: string;
  documentId?: number;
  documentName?: string;
  onFileSelected?: (file: File) => void;
  playbookUuid?: string;
  projectUuid?: string;
  maxFiles?: number;
  allowedExtensions?: string[];
  auditEntry?: any;
  tags?: any[];
  onTagsChanged?: (tags: any[]) => void;
}

const initialState: ModalState = {
  showModal: false,
  type: 'custom',
  message: '',
  info: '',
  title: '',
  width: '',
  subMsg: '',
  inputData: '',
  folderOptions: undefined,
  selectedModel: undefined,
  date: '',
  taskId: [],
  fileID: '',
  preSelectedFolderId: '',
  duration: undefined,
  onConfirm: undefined,
  onCancel: undefined,
  clientId: '',
  caseId: '',
  files: [],
  onFilesChange: () => {},
};

export const modalReducer = (state = initialState, action: AnyAction): ModalState => {
  switch (action.type) {
    case 'SHOW_MODAL':
      return {
        ...state,
        ...action.payload,
        showModal: true,
        onFilesChange: action.payload.onFilesChange || state.onFilesChange,
      };
    case 'HIDE_MODAL':
      return {
        ...initialState,
        showModal: false,
      };
    default:
      return state;
  }
};
